import React from 'react';
import PropTypes from 'prop-types';

import { Loader } from 'components/Loader';

import './style.scss';

const Button = ({ className, onClick, disabled, type, loader, style, children }) => {
  const handleClick = (e) => {
    return !disabled && onClick(e);
  };

  const styles = { ...style };

  if (loader) {
    styles.padding = '4.8px';
  }

  return (
    <button type={type} className={`btn ${className}`} onClick={handleClick} style={styles}>
      {loader ? <Loader color="#fff" type="small" /> : children}
    </button>
  );
};

Button.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  loader: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Button.defaultProps = {
  type: 'button',
  className: '',
  disabled: false,
  loader: false,
  style: {},
  onClick: () => {},
};

export { Button };
